import { useState } from 'react';
import { Tabs, Title, Box } from '@mantine/core';
import {
  IconLayoutDashboard, IconUsers, IconBook, IconDatabase, IconCurrencyDollar,
} from '@tabler/icons-react';
import AdminDashboard from '../components/admin/AdminDashboard';
import UserManagement from '../components/admin/UserManagement';
import CertificationManagement from '../components/admin/CertificationManagement';
import ScrapeControl from '../components/admin/ScrapeControl';
import CostDashboard from '../components/admin/CostDashboard';

/**
 * 管理画面ルートページ
 * タブ切替で各管理機能（ダッシュボード・ユーザー・資格・スクレイピング）を表示する
 * AdminRoute によって admin ロールを持つユーザーのみアクセス可能
 */
function Admin() {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <Box>
      <Title order={2} mb="md">管理画面</Title>

      <Tabs value={activeTab} onChange={setActiveTab}>
        <Tabs.List mb="lg">
          <Tabs.Tab value="dashboard" leftSection={<IconLayoutDashboard size={16} />}>
            ダッシュボード
          </Tabs.Tab>
          <Tabs.Tab value="users" leftSection={<IconUsers size={16} />}>
            ユーザー管理
          </Tabs.Tab>
          <Tabs.Tab value="certifications" leftSection={<IconBook size={16} />}>
            資格管理
          </Tabs.Tab>
          <Tabs.Tab value="scrape" leftSection={<IconDatabase size={16} />}>
            スクレイピング
          </Tabs.Tab>
          <Tabs.Tab value="costs" leftSection={<IconCurrencyDollar size={16} />}>
            コスト
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="dashboard">
          <AdminDashboard />
        </Tabs.Panel>

        <Tabs.Panel value="users">
          <UserManagement />
        </Tabs.Panel>

        <Tabs.Panel value="certifications">
          <CertificationManagement />
        </Tabs.Panel>

        <Tabs.Panel value="scrape">
          <ScrapeControl />
        </Tabs.Panel>

        <Tabs.Panel value="costs">
          <CostDashboard />
        </Tabs.Panel>
      </Tabs>
    </Box>
  );
}

export default Admin;
